const getCurrentRegionList = () => {
    if (window.currentRegion && window.regionList) {
        const currentReg = window.currentRegion.split('[]')[0];
        const allRegions = window.regionList.split(', ').filter((allRegItem) => allRegItem.split('[]')[0] === currentReg);
        return allRegions;
    }
    return [];
};
const getLanguagesForRegion = () => {
    const allRegions = getCurrentRegionList();
    const languages = allRegions.filter((localRegItem) => localRegItem.split('[]')[4] === 'false').map((item) => item.split('[]')[2]);
    return languages;
};
const cleanLangURL = () => {
    let formattedPath = window.location.pathname;
    const languages = getLanguagesForRegion();
    languages.forEach((langItem) => {
        return (formattedPath = formattedPath.split(`/${langItem}`).join(''));
    });
    return formattedPath;
};
const getSelectedLanguage = () => {
    const languages = getLanguagesForRegion();
    let currentLang = '';
    languages.forEach((langItem) => {
        if (window.location.pathname.includes(`/${langItem}`)) {
            return (currentLang = langItem);
        }
    });
    return currentLang;
};
const getSelectedRegionString = () => {
    const currentRegionList = getCurrentRegionList();
    const currentLanguage = getSelectedLanguage();
    const [selectedRegion] = currentRegionList.filter((regItem) => regItem.split('[]')[2] === currentLanguage);
    let currentRegion = window.currentRegion;
    if (selectedRegion) {
        currentRegion = selectedRegion;
    }
    else {
        [currentRegion] = currentRegionList.filter((regItem) => regItem.split('[]')[4] === 'true');
    }
    return currentRegion;
};
const EUCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'ES', 'FI', 'FR', 'DE', 'GB', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
const getGroupedRegion = (code) => {
    let EUCountry = EUCountries.includes(code);
    if (EUCountry) {
        return 'GBR';
    }
    return code;
};
export { getLanguagesForRegion, cleanLangURL, getSelectedLanguage, getCurrentRegionList, getSelectedRegionString, getGroupedRegion };
